import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 9px;
`;

const Title = styled.div`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 14px;
  font-style: italic;
  line-height: 18px;
  color: ${props => props.theme.secondaryColor};
  text-transform: uppercase;
`;

const Link = styled.a`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 14px;
  font-style: italic;
  line-height: 18px;
  color: ${props => props.theme.primaryColor};
  margin: 0 20px;
  cursor: pointer;
  text-decoration: none !important;
`;

const BottomLink = styled(Link)`
  margin-top: 8px;
  margin-left: 0;
`;

const Button = styled.span`
  font-size: 14px;
  line-height: 18px;
  color: ${props => props.theme.secondaryColor};
  cursor: pointer;
  position: absolute;
  right: 0;
`;

const SectionSeparator = styled.hr`
  width: ${props => props.length || '148'}px;
  margin: 8px 0;
  border: 0.02em solid ${props => props.theme.primaryColor};
`;

export {
  Button,
  Link,
  BottomLink,
  Container,
  SectionSeparator,
  TitleContainer,
  Title,
};
